import { createServerFn } from '@tanstack/react-start'
import { getFromS3, listFromS3 } from '../../lib/s3'
import type { User } from './userSchemas'

export const getUsers = createServerFn({ method: 'GET' }).handler(
  async (): Promise<User[]> => {
    const keys = await listFromS3('users/')
    const userKeys = keys.filter((k): k is string => !!k && k.endsWith('.json'))
    const users = await Promise.all(userKeys.map((key) => getFromS3(key) as Promise<User>))
    return users
  },
)
